import { render, staticRenderFns } from "./AttributeTableWin.vue?vue&type=template&id=57d49e62&scoped=true&"
import script from "./AttributeTableWin.vue?vue&type=script&lang=js&"
export * from "./AttributeTableWin.vue?vue&type=script&lang=js&"
import style0 from "./AttributeTableWin.vue?vue&type=style&index=0&id=57d49e62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d49e62",
  null
  
)

export default component.exports